// 비로그인 조회 검증(PoW)
// 서버가 낸 문제(challenge = SHA-256(salt + n))의 n(0 ~ maxNumber)을 찾아 요청 헤더 토큰으로 만든다.
// 사용: Send({ ..., headers: await powHeaders(Send, '/{모듈}/pow/challenge') })

const TOKEN_HEADER = 'pow-token'
const BATCH_SIZE = 1000 // 한 번에 병렬로 계산할 해시 개수

async function sha256Hex (text) {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text))
  return Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('')
}

async function findNumber ({ salt, challenge, maxNumber }) {
  for (let start = 0; start <= maxNumber; start += BATCH_SIZE) {
    const end = Math.min(start + BATCH_SIZE - 1, maxNumber)
    const numbers = Array.from({ length: end - start + 1 }, (_, i) => start + i)
    const hashes = await Promise.all(numbers.map(n => sha256Hex(salt + n)))
    const found = hashes.indexOf(challenge)
    if (found >= 0) return numbers[found]
  }
  return null
}

// 토큰 'salt.n.challenge.signature' (풀이할 수 없는 환경이면 null)
async function createPowToken (challengeResp) {
  if (!window.crypto?.subtle) return null // Web Crypto 는 https·localhost 에서만 동작
  const number = await findNumber(challengeResp)
  if (number === null) return null
  return [challengeResp.salt, number, challengeResp.challenge, challengeResp.signature].join('.')
}

// 비로그인이면 챌린지를 받아 풀고 토큰 헤더를 만든다. (로그인 사용자는 서버에서 면제)
// 발급·풀이에 실패하면 빈 헤더로 진행하고 판단은 서버에 맡긴다. (배포 순서 무관)
export async function powHeaders (send, challengeUrl) {
  if (sessionStorage.getItem('access_token')) return {}
  try {
    const res = await send({ url: challengeUrl, method: 'get' })
    const token = await createPowToken(res.data)
    return token ? { [TOKEN_HEADER]: token } : {}
  } catch (e) {
    return {}
  }
}
